import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";
import { QuestionIsNotDiscountTarget } from "@/components/features/items/edit/_shared/ui/components/main/questions/discount-setting";

import { useProductRoomFormModelContext } from "../../context";
import { useIsNotDiscountTarget } from "../connection/discount-setting/hooks";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	discountSetting: StandardRoomCategoriesAndManagerStore["discountSetting"];
};

export const QuestionRoomDiscountSetting = ({ discountSetting }: Props) => {
	const { isNotDiscountTarget, onSetIsNotDiscountTarget } = useIsNotDiscountTarget();
	const { queryData } = useProductRoomFormModelContext();
	const activeOrdinaryRoomDiscounts =
		queryData.discountList?.ordinary.filter((discount) => discount.isRoomDiscountEligible) ?? [];

	if (!isNotDiscountTarget) {
		return null;
	}

	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="ディスカウント適用設定" categoryStore={discountSetting}>
			<QuestionIsNotDiscountTarget
				isNotDiscountTarget={isNotDiscountTarget}
				onSetIsNotDiscountTarget={onSetIsNotDiscountTarget}
				activeDiscounts={activeOrdinaryRoomDiscounts}
				title="この部屋に適用されているディスカウント一覧"
				description={
					<div className="rounded-md border bg-zinc-50 p-3">
						<p className="text-sm text-zinc-600">
							<b>ディスカウントの適用優先順位について:</b>
							<br />
							「ディスカウントの適用対象から外す」にチェックが入っている場合、その設定が優先され、この部屋には一切のディスカウントが適用されません。
							<br />
							ディスカウント設定側で適用対象にチェックが入っていない場合は、こちらの除外設定に関わらず、ディスカウントは適用されません。
							<br />
						</p>
					</div>
				}
			/>
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomDiscountSetting.displayName = "QuestionRoomDiscountSetting";
